import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import PopUp from '../../body/PopUp';

const ModuleTasksPopup = ({ opened, onClose }) => {
  if (!opened) return null; // Ensure the popup only renders when opened is true
  return (
    <PopUp header='Introduction Module Tasks' opened={opened} onClose={onClose}>
      <ul className='pl-6 space-y-2'>
        <li>✅ Learn about the Program </li>
        <li>✅ Watch Videos </li>
        <li>✅ Take a Quiz - 80% or higher required to move on</li>
      </ul>
      <p
        className='text-center
      font-bold
      '
      >
        This module should take about 15 minutes.
      </p>
    </PopUp>
  );
};

const ModObjectives = () => {
  const [opened, setOpened] = React.useState(true);

  return (
    <>
      <ModuleTasksPopup opened={opened} onClose={() => setOpened(false)} />
      <VideoSlide vidSrc={1198792953}></VideoSlide>
    </>
  );
};

export default ModObjectives;
